unit NetNumberStatusSetType;

interface

type

  TNetNumberStatusSetType = class
  private
    netNumberKey: String;
    netStatusKey: String;
    deviceKey: String;
    temperatureKey: String;
    charge: String;
  public
    constructor Create(const String_NetNumberKey: String; const String_NetStatusKey: String;  const String_DeviceKey: String; const String_TemperatureKey: String; const String_Charge: String);
  end;

implementation

constructor TNetNumberStatusSetType.Create(const String_NetNumberKey: String; const String_NetStatusKey: String;  const String_DeviceKey: String; const String_TemperatureKey: String; const String_Charge: String);
begin
  netNumberKey := String_NetNumberKey;
  netStatusKey := String_NetStatusKey;
  deviceKey := String_DeviceKey;
  temperatureKey := String_TemperatureKey;
  charge := String_Charge;
end;

end.
